module.exports = __webpack_public_path__ + "img/left.9c83f034.svg";